import { styled, css, Box, CircularProgress } from '@mui/material'
import { ViewItemProps, ViewSpinnerProps } from './ViewObserver.types'

export const ViewObserverWrapper = styled(Box)(
  () => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 1px;
    width: 100%;
  `
)

export const ViewItem = styled(Box)<ViewItemProps>(
  ({ offset }) => css`
    z-index: -9999;
    position: absolute;
    inset: -${offset}px 0;

    *:first-of-type > & {
      top: 0;
    }

    *:last-of-type > & {
      bottom: 0;
    }
  `
)

export const ViewSpinner = styled(CircularProgress, {
  shouldForwardProp: (prop) => !['show'].includes(String(prop))
})<ViewSpinnerProps>(
  ({ show }) => css`
    margin: ${show ? 18 : 0}px;
    width: ${show ? 40 : 0}px !important;
    height: ${show ? 40 : 0}px !important;
    transition: width 0.1s, height 0.1s, margin 0.1s, opacity 0.1s;
  `
)
